module.exports = __webpack_public_path__ + "static/media/2017sh.0643e545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/images/2017sh.jpg
// module id = 259
// module chunks = 0